import React from 'react';
import { translate } from 'react-i18next';

import TimeSheetLocationitem from 'components/timesheets/TimeSheetLocationitem.js';
import Popover from 'components/popover/Popover.js';

class TimeSheetLocationNav extends React.Component {
  constructor(props) {
    super(props);

    this._handlePopoverClose = this._handlePopoverClose.bind(this);
    this._toggleLocationsNav = this._toggleLocationsNav.bind(this);
    this._onLocationClicked = this._onLocationClicked.bind(this);

    this.state = {
      popOverActive: false,
      popTarget: null,
    };
  }

  _onClosePopover(e) {
    this._handlePopoverClose();
  }

  _handlePopoverClose() {
    this.setState({
      popOverActive: false,
      popTarget: null,
    });
  }

  _toggleLocationsNav(e) {
    this.setState({
      popOverActive: !this.state.popOverActive,
      popTarget: e.currentTarget,
    });
  }

  _onLocationClicked(id) {
    this.props.onLocationChange(id);
    this._handlePopoverClose();
  }

  render() {
    return (
      <div id="location-nav">
        <a onClick={this._toggleLocationsNav}>{this.props.t('TimeSheetLocationNav.switch_location')}</a>
        <Popover
          position="top"
          className="locations-menu"
          onHide={this._handlePopoverClose}
          active={this.state.popOverActive}
          popTarget={this.state.popTarget}
        >
          <ul>
            {_.isArray(this.props.locations)
              && this.props.locations.map(function (location, index) {
                return (
                  <TimeSheetLocationitem
                    location={location}
                    key={index}
                    active={location.id == this.props.currentLocation.id}
                    onLocationChange={this._onLocationClicked}
                  />
                );
              }, this)}
          </ul>
        </Popover>
      </div>
    );
  }
}

export default translate()(TimeSheetLocationNav);
